import { IPaginationProps } from "./TableTypes"
import Select from "components/UI/atoms/Select"
import { Flex, Box, Center, } from "@chakra-ui/react"
import { splitPagination } from "utils/splitPagination"
import Icon from "components/UI/atoms/Icon"
import { useLocation } from "react-router-dom"

const Pagination: React.FC<IPaginationProps> = ({ total, perPage, onClick, currentPage, siblingsCount = 1, value, handleTableSize }) => {
  const { pathname } = useLocation()
  const pagesCount = Math.ceil(total / perPage)

  const paginations = splitPagination({ currentPage, pagesCount, siblingsCount })

  const renderPageNumber = (pageNumber: number) => (
    <Center
      as="button"
      mr="10px"
      w="20px"
      h="20px"
      border="1px solid"
      borderColor="primary"
      key={pageNumber}
      onClick={() => onClick(pageNumber)}
      fontSize="base"
      borderRadius="3px"
      backgroundColor={currentPage === pageNumber ? "primary" : "transparent"}
      color={currentPage === pageNumber ? "white" : "main_text_color"}
    >
      {pageNumber}
    </Center>
  )

  const renderDots = () => (
    <Box mr="10px">
      <Icon name="dots_horz" iconStyles={{ width: "16px", height: "16px", fill: "black" }} />
    </Box>
  )

  return (
    <Flex m="0" p="10px" textAlign="center" maxWidth="100%">
      <Flex style={{ display: "none" }}>{"In order to center buttons"}</Flex>
      <Flex alignItems="center" width="100%" justifyContent="center" marginLeft="62px" marginTop="4px">
        <Box
          as="button"
          opacity={currentPage === 1 ? "0.3" : "1"}
          pointerEvents={currentPage === 1 ? "none" : "auto"}
          onClick={() => onClick(currentPage - 1)}
        >
          <Icon name="arrowLeft" iconStyles={{ width: "16px", height: "16px", fill: "black" }} />
        </Box>
        <Box
          as="button"
          mr="10px"
          opacity={currentPage < 3 ? "0.3" : "1"}
          pointerEvents={currentPage === 1 ? "none" : "auto"}
          onClick={() => onClick(currentPage - 2)}
        >
          <Icon name="double_arrow_left" iconStyles={{ width: "16px", height: "16px", fill: "black" }} />
        </Box>
        {paginations.showLeftDots && renderPageNumber(1)}
        {paginations.showLeftDots && renderDots()}
        {paginations.pages.map((pageNumber) => renderPageNumber(pageNumber))}
        {paginations.showRightDots && renderDots()}
        {paginations.showRightDots && renderPageNumber(pagesCount)}
        <Box
          as="button"
          opacity={currentPage > (pagesCount - 2) ? "0.3" : "1"}
          pointerEvents={currentPage > (pagesCount - 2) ? "none" : "auto"}
          onClick={() => onClick(currentPage + 2)}
        >
          <Icon name="double_arrow_right" iconStyles={{ width: "16px", height: "16px", fill: "black" }} />
        </Box>
        <Box
          as="button"
          opacity={currentPage === pagesCount ? "0.3" : "1"}
          pointerEvents={currentPage === pagesCount ? "none" : "auto"}
          onClick={() => onClick(currentPage + 1)}
        >
          <Icon name="arrowRight" iconStyles={{ width: "16px", height: "16px", fill: "black" }} />
        </Box>
      </Flex>
      <Flex style={{ alignItems: "center", justifyContent: "center" }} marginRight="53px">
        {pathname.includes("reservations") &&
          <Select

            options={[
              { label: "10", value: 10 },
              { label: "20", value: 20 },
              { label: "30", value: 30 },
              { label: "50", value: 50 },
            ]}
            value={value}
            placeholder={value}
            maxMenuHeight={175}
            onChange={handleTableSize}
            selectWidth="59px"

          />
        }
      </Flex>

    </Flex>
  )
}

export default Pagination